$(function () {

  // ヘッダーの高さ取得
  var height = 0;
  if ($('#header').length) {
    height = $("#header").height();
  }

  // ----------------------------------------------
  // グローバルナビ
  // ----------------------------------------------
  // $(window).on('load', function(){
  $(document).ready(function () {
    var winTop = 0;
    var $menuBtn = $('.g-header__sp-menu-btn');
    var $menuTarget = $('.g-nav');
    var $menuOpenClass = 'is-open';

    //グロナビクリック：SP
    $menuBtn.on('click', function (e) {
      if (!$menuBtn.hasClass($menuOpenClass)) {
        $menuBtn.addClass($menuOpenClass);
        $menuTarget.addClass($menuOpenClass);
        if (window.matchMedia('(max-width:1024px)').matches) {
          winTop = $(window).scrollTop();
          $('html').css({
            'overflow': 'hidden',
          });
        }
      } else {
        $menuBtn.removeClass($menuOpenClass);
        $menuTarget.removeClass($menuOpenClass);
        $('html').removeAttr('style');
        $(window).scrollTop(winTop);
      }
      return false;
    });

    //グロナビホバー：PC

    $('#header-modalBtn').hover(
      function () {
        $('#header-modalContent').stop().fadeIn();
        $('#g-header-bottom-left-banner').toggleClass("hover");
      },
      function () {
        $('#header-modalContent').stop().fadeOut();
        $('#g-header-bottom-left-banner').toggleClass("hover");
      }
    );

    //比較のヘルプホバー
    $('.help-btn').hover(
      function () {
        $(this).next('.help-detail').stop().fadeIn();
      },
      function () {
        $(this).next('.help-detail').stop().fadeOut();
      }
    );
  });

  // ----------------------------------------------
  // ローディング画面
  // ----------------------------------------------
  function loading_spinner() {
    const spinner = document.getElementById('loading');
    spinner.classList.add('loaded');
  };
  if (document.readyState !== "loading") { // DOM読み込み完了していたら即時実行
    loading_spinner();
  } else { // DOM読み込み時に実行
    document.addEventListener("DOMContentLoaded", loading_spinner, false);
  }

  // ----------------------------------------------
  // スクロールイベント
  // ----------------------------------------------
  $(window).on('load scroll', function () {
    if ($(window).scrollTop() > 0) {
      $('body').addClass('body-scroll');
    } else {
      $('body').removeClass('body-scroll');
    }
  });
  var scroll = 0;
  $(window).on('scroll', function () {
    if ($(this).scrollTop() > scroll) {
      //上スクロールの時の処理
      $('body').addClass('body-scrolldown');
    } else {
      //下スクロールの時の処理
      $('body').removeClass('body-scrolldown');
    }
    scroll = $(this).scrollTop();
  });

  // ----------------------------------------------
  // スマホ 画面幅を超えた際、横スクロールを促す
  // ----------------------------------------------
  new ScrollHint('.js-scrollable', {
    suggestiveShadow: true, //スクロール可能な要素右端に影を付ける
    i18n: {
      scrollable: '' //表示するテキスト
    }
  });
  // $.prototype.draggable = function () {
  //   var t;
  //   $(this).each(function (i, e) {
  //     $(e).mousedown(function (e2) {
  //       e2.preventDefault();
  //       t = $(e);
  //       $(e).data({
  //         down: true,
  //         x: e2.clientX,
  //         y: e2.clientY,
  //         left: $(e).scrollLeft(),
  //         top: $(e).scrollTop()
  //       });
  //     });
  //   });
  //   $(document).mousemove(function (e) {
  //     if ($(t).data("down")) {
  //       e.preventDefault();
  //       $(t).scrollLeft($(t).data("x") + $(t).data("left") - e.clientX);
  //       $(t).scrollTop($(t).data("y") + $(t).data("top") - e.clientY);
  //     }
  //   }).mouseup(function (e) {
  //     $(t).data("down", false);
  //   });
  // };
  // $(".js-scrollable").draggable();

  // テーブル行全体をクリッカブルにする
  jQuery(function ($) {
    $("tbody td[data-href]")
      .addClass("clickable")
      .click(function () {
        window.location = $(this).attr("data-href");
      })
      .find("a")
  });

  // ページ内リンクのスムーススクロール
  $('a[href^="#"]').click(function (e) {
    if (e.target.id !== 'pt-nav-toggle') {
      // スクロールの速度
      var speed = 400; // ミリ秒
      // アンカーの値取得
      var href = jQuery(this).attr("href");
      // 移動先を取得
      var target = jQuery(href == "#" || href == "" ? 'html' : href);
      // 移動先を数値で取得
      var position = target.offset().top - height;
      // スムーススクロール
      jQuery('body,html').animate({ scrollTop: position }, speed, 'swing');
      return false;
    }
  });

  $('.hubspotForm_Btn,#hubspot_modal-bg,#hubspot_modal-close').click(
    function () {
      if ($('#hubspot_modal').hasClass('active')) {
        $('#hubspot_modal,.hubspotForm_Btn').toggleClass('active');
        $('#hubspot_modal').stop().fadeOut();
      } else {
        $('#hubspot_modal,.hubspotForm_Btn').toggleClass('active');
        $('#hubspot_modal').stop().fadeIn();
      }
    }
  );

  $('.acord_ttl').click(function () {
    if ($(this).hasClass('active')) {
      $(this).toggleClass('active');
      $(this).siblings('.acord_item').stop().slideToggle();
    } else {
      $(this).toggleClass('active');
      $(this).siblings('.acord_item').stop().slideToggle();
    }
  });

});